import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setOrdersSelectedInControlPanel } from 'src/app/redux/actions/control-panel.action';
import { resetLastUpdate, setLocation } from 'src/app/redux/actions/options.action';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { isProduction } from 'src/app/shared/const/options';
import { areas } from '@shared-logic/user';
import { DateChecker } from '@shared-logic/utils';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order } from '@shared-logic/orders';
import { User } from '@shared-logic/user/user.interface';
import { MaestrosService } from 'src/app/shared/services/mestros.service';
import { OrderService } from 'src/app/shared/services/order.service';
import { DataRefreshService } from 'src/app/shared/services/data-refresh.service';
import { SessionChecker } from 'src/app/shared/session.checker';
import { TablesIBMClass } from 'src/app/shared/tables-ibm';
import { selectAllControlPanelOrders } from 'src/app/redux/selectors/orders.selectors';

@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html',
  styleUrls: ['./../../shared/styles/body.scss']
})
export class ControlPanelComponent extends TablesIBMClass implements OnInit {
  public user!: User;

  private controlPanel$!: Subscription;
  private user$!: Subscription;

  constructor(private store: Store<appState>, private checker: SessionChecker, private router: Router,
    maestroSvc: MaestrosService,
    private dataRefreshService: DataRefreshService) {
    super(maestroSvc);
    this.loadOrders();

    this.checker.rememberAndActualizateUser(this.store);

    this.store.dispatch(setLocation({ location: NAVEGATION.CONTROL_PANEL }));
  }


  ngOnInit(): void {
    this.setSubscriptions();
    this.checkIsComercial();
    this.checkTables();
  }

  ngOnDestroy(): void {
    this.user$?.unsubscribe();
    this.controlPanel$?.unsubscribe();

    this.store.dispatch(setOrdersSelectedInControlPanel({ orders: [] }));
    this.store.dispatch(resetLastUpdate());
  }

  setSubscriptions() {
    this.user$ = this.store.select('usuario').subscribe((usuario: User) => {
      this.user = usuario;
    })
  }


  checkIsComercial() {
    if (this.user.area == areas.comercial && isProduction()) {
      this.router.navigate(['/' + NAVEGATION.HOME]);
    }
  }

  //Esto es lo mismo que está en order list
  loadOrders() {
    this.dataRefreshService.refreshOrders(true);
  }

}
